export const title = 'Ticket médio';

Ticket médio das vendas.